import * as Unicons from '@iconscout/react-unicons';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../assets/img/sidebar/logo-grande.png';
import { useGlobalContext } from '../../context/GlobalContext';
import { useNotificationService } from '../../services/notification.service';
import { useUsuarioService } from '../../services/usuario.service';
import { useTranslation } from 'react-i18next';

interface TInputs {
  email: string;
}

export const Senha: React.FunctionComponent = () => {
  const { t } = useTranslation(['common', 'login']);
  const { register, handleSubmit } = useForm<TInputs>();
  const notification = useNotificationService();
  const userService = useUsuarioService();
  const navigate = useNavigate();
  const { setIsGlobalLoading } = useGlobalContext();

  const onRecuperaSenha = (data: TInputs) => {
    setIsGlobalLoading(true);
    userService
      .recuperaSenha(data.email)
      .then(() => {
        notification({
          message: t('common:success'),
          description: t('login:successMessage', { email: data.email, defaultValue: '' }),
          type: 'info',
        });
        navigate('');
      })
      .finally(() => setIsGlobalLoading(false));
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onRecuperaSenha)}
        className="container-login"
        style={{ backgroundColor: 'var(--white-color' }}
      >
        <div className="formulario-box">
          <div className="formulario forget-password">
            <div className="arrow">
              <Link to="/login" style={{display: 'flex', alignItems: 'center'}}>
                <Unicons.UilArrowLeft size="24" color="#ffffff" />
                <span>{t('common:back')}</span>
              </Link>
            </div>
            <img src={Logo} alt={'logo'} className="logo-login" style={{display:'block',alignContent:'center'}}/>
            <h3>{t('login:forgotPassword')}</h3> 
            <div className="input">
              <Unicons.UilEnvelopeAlt
                size="20"
                color="#6A7C96"
                className="iconForm"
              />
              <input
                {...register('email', { required: true })}
                type="text"
                placeholder="Email"
              />
            </div>
            <button
              type="submit"
              className="button-second"
              style={{ width: '100%', height: 56 }}
            >
              <span>{t('common:send')}</span>
            </button>
          </div>
        </div>
        <div className="container-blue"></div>
      </form>
    </>
  );
};
